/* eslint-disable react/jsx-props-no-spreading */
import React from '../../../../../lib/teact/teact';

export const HowToClaim3 = (props: any) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="0.5"
        y="0.5"
        width="23"
        height="23"
        rx="11.5"
        fill="var(--color-secondary)"
      />
      <rect
        x="0.5"
        y="0.5"
        width="23"
        height="23"
        rx="11.5"
        stroke="currentColor"
      />
      <g clip-path="url(#clip0_8209_29437)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11.45 8.55682V9.25031C11.45 9.55407 11.2038 9.80031 10.9 9.80031C10.0707 9.8001 9.26355 10.0676 8.59859 10.5631C8.01486 10.9981 7.56812 11.5883 7.3074 12.2635C7.24265 12.4312 7.08628 12.5502 6.90651 12.5502C6.682 12.5502 6.5 12.7322 6.5 12.9567V14.3436C6.5 14.5681 6.682 14.7501 6.90651 14.7501C7.08628 14.7501 7.24265 14.8691 7.3074 15.0368C7.56812 15.7121 8.01486 16.3022 8.59859 16.7372C9.26355 17.2327 10.0707 17.5002 10.9 17.5H13.1C13.9293 17.5002 14.7364 17.2327 15.4014 16.7372C15.9851 16.3022 16.4319 15.712 16.6926 15.0368C16.7574 14.8691 16.9137 14.7501 17.0935 14.7501C17.318 14.7501 17.5 14.5681 17.5 14.3436V12.9567C17.5 12.7322 17.318 12.5502 17.0935 12.5502C16.9137 12.5502 16.7574 12.4312 16.6926 12.2635C16.4319 11.5883 15.9851 10.9981 15.4014 10.5631C14.7364 10.0676 13.9293 9.8001 13.1 9.80031C12.7962 9.80031 12.55 9.55407 12.55 9.25031V8.56011C12.7609 8.4396 12.9261 8.25285 13.0199 8.02884C13.1138 7.80483 13.1311 7.5561 13.0691 7.32126C13.0071 7.08643 12.8693 6.87863 12.6771 6.73013C12.4849 6.58163 12.2491 6.50073 12.0062 6.5C11.7633 6.49928 11.527 6.57876 11.3339 6.7261C11.1408 6.87345 11.0017 7.08041 10.9383 7.31487C10.8749 7.54933 10.8907 7.79816 10.9832 8.02273C11.0758 8.2473 11.2398 8.43505 11.45 8.55682ZM8.15 13.6502C8.15 12.9208 8.43973 12.2214 8.95545 11.7057C9.47118 11.19 10.1707 10.9003 10.9 10.9003H13.1C13.8293 10.9003 14.5288 11.19 15.0445 11.7057C15.5603 12.2214 15.85 12.9208 15.85 13.6502V13.6573C15.8481 14.3854 15.5575 15.083 15.042 15.5971C14.5265 16.1113 13.8281 16.4 13.1 16.4H10.9C10.1707 16.4 9.47118 16.1103 8.95545 15.5946C8.43973 15.0789 8.15 14.3795 8.15 13.6502ZM13.65 13.1002C13.3463 13.1002 13.1 13.3464 13.1 13.6502C13.1 13.9539 13.3463 14.2001 13.65 14.2001C13.9537 14.2001 14.2 13.9539 14.2 13.6502C14.2 13.3464 13.9537 13.1002 13.65 13.1002ZM10.35 13.1002C10.0463 13.1002 9.8 13.3464 9.8 13.6502C9.8 13.9539 10.0463 14.2001 10.35 14.2001C10.6537 14.2001 10.9 13.9539 10.9 13.6502C10.9 13.3464 10.6537 13.1002 10.35 13.1002Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_8209_29437">
          <rect
            width="11"
            height="11"
            fill="currentColor"
            transform="translate(6.5 6.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
